import { Component } from '@angular/core';

@Component({
  selector: 'nearby-app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})
export class AppComponent {

  // public ngOnInit() {
  //   if (isDevMode()) {
  //     console.log('Development!');
  //   } else {
  //     console.log('Production!');
  //   }
  // }
}
